import React from 'react'
import { useFetch } from '../../hooks/useFetch'
import { Container, Box, Grid, TextField, Typography, Button, Divider, Card, Paper, CardActions, CardContent } from '@mui/material/'
import { useState, useEffect } from 'react';
import CircularProgress from '@mui/material/CircularProgress'
import { useNavigate } from 'react-router-dom'


import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Stack from '@mui/material/Stack';


import CancelIcon from '@mui/icons-material/Cancel';
import ThumbDownOffAltIcon from '@mui/icons-material/ThumbDownOffAlt';

import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import DescriptionIcon from '@mui/icons-material/Description';
import useEnhancedEffect from '@mui/material/utils/useEnhancedEffect';
function ViewTerms({ quoteId, setViewOrder, setViewTerms, setOrderId, setPaymentReqId, setReturnCheckSum, setTotal }) {



    const [ipAddress, setIPAddress] = useState('')

    useEffect(() => {
        fetch('https://api.ipify.org?format=json')
            .then(response => response.json())
            .then(data => setIPAddress(data.ip))
            .then(console.log("My ip address is " + ipAddress))
            .catch(error => console.log(error))
    }, [ipAddress]);


    const [conf1, setConf1] = useState(false)
    const [conf2, setConf2] = useState(false)

    const navigate = useNavigate()
    const { postData: AcceptQuote, error, errorMessage, isPending, data: quoteAccepted } = useFetch(`https://dcregapi.bi-oss.co.za/orders/createfromquote/${quoteId}`, 'POST')
    const { updateData: DeclineQuote, error: error2, errorMessage: errorMessage2, isPending: isPending2, data: quoteDeclined } = useFetch(`https://dcregapi.bi-oss.co.za/quote/declineterms/${quoteId}`, 'PUT')



    const handleSubmit = (e) => {
        e.preventDefault()
        AcceptQuote({
            ipAddress
        })

    }

    const handleDecline = (e) => {

        window.location.reload();


    }



    useEffect(() => {
        if (quoteAccepted) {
            quoteAccepted.map(data => {
                setOrderId(data.orderId)
                setReturnCheckSum(data.returnChecksum)
                setPaymentReqId(data.paymentReqId)
                setTotal(data.total)
            })

            setViewTerms(0)
            setViewOrder(1)
        }
    }, [quoteAccepted])

    useEffect(() => {
        if (quoteDeclined) {
            navigate('./')
        }
    }, [quoteDeclined])


    return (
        <Container maxWidth="md">
            <>
                <Box mb={5} />




                <form onSubmit={handleSubmit}>
                    <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }} sx={{ border: 'solid', borderWidth: '3px', borderColor: "primary.main", borderRadius: 2 }}>


                        <Grid item xs={12}>
                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"

                            >
                                <Typography variant="h3" component="h3" color="primary.main" sx={{ textAlign: 'center' }}>
                                    Terms and Conditions
                                </Typography>

                            </Box>
                        </Grid>
                        <Grid item xs={12}>

                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{

                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto'
                                }}
                            >


                                <Typography variant="body2" component="p" color="primary.main" sx={{ textAlign: 'center' }}>
                                    Before you can generate an entry quote, all terms,conditions, entry rules and code of conduct must be accepted.
                                </Typography>





                            </Box>


                        </Grid>

                        <Grid item xs={12}>

                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{

                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto'
                                }}
                            >


                                <Typography variant="body2" component="p" color="primary.main" sx={{ textAlign: 'center' }}>
                                    To view our Terms and Conditions, visit <a href="./tnc" target='blank'>https://dcreg.bi-oss.co.za/tnc</a>.

                                </Typography>





                            </Box>


                        </Grid>

                        <Grid item xs={12}>

                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{

                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto'
                                }}
                            >


                                <Typography variant="body2" component="p" color="primary.main" sx={{ textAlign: 'center' }}>

                                    By clicking agree, I state that I have read, understood and agree to all the terms and conditions in the above link.

                                </Typography>





                            </Box>


                        </Grid>
                        <Grid item xs={12}>

                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{

                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto'
                                }}
                            >

                                <FormGroup>

                                    <Stack direction="row" spacing={1} alignItems="center">
                                        <Typography>Decline</Typography>

                                        {conf1 === false && (
                                            <Switch checked={false} required inputProps={{ 'aria-label': 'ant design' }} onChange={(e) => setConf1(true)} />

                                        )}
                                        {conf1 === true && (
                                            <Switch color="success" checked={true} required inputProps={{ 'aria-label': 'ant design' }} onChange={(e) => setConf1(false)} />

                                        )}
                                        <Typography>I Agree. </Typography>
                                    </Stack>
                                </FormGroup>


                            </Box>


                        </Grid>


                        <Grid item xs={12}>

                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{

                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto'
                                }}
                            >


                                <Typography variant="body2" component="p" color="primary.main" sx={{ textAlign: 'center' }}>
                                    To view the Code of Conduct, visit <a href="./conduct" target='blank'>https://dcreg.bi-oss.co.za/conduct</a>.

                                </Typography>





                            </Box>


                        </Grid>

                        <Grid item xs={12}>

                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{

                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto'
                                }}
                            >


                                <Typography variant="body2" component="p" color="primary.main" sx={{ textAlign: 'center' }}>


                                    By clicking agree, I state that I have read, understood and agree to all the Code of Conduct as per the above link.
                                </Typography>





                            </Box>


                        </Grid>

                        <Grid item xs={12}>

                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{

                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto'
                                }}
                            >

                                <FormGroup>

                                    <Stack direction="row" spacing={1} alignItems="center">
                                        <Typography>Decline</Typography>

                                        {conf2 === false && (
                                            <Switch checked={false} required inputProps={{ 'aria-label': 'ant design' }} onChange={(e) => setConf2(true)} />

                                        )}
                                        {conf2 === true && (
                                            <Switch color="success" checked={true} required inputProps={{ 'aria-label': 'ant design' }} onChange={(e) => setConf2(false)} />

                                        )}
                                        <Typography>I Agree. </Typography>
                                    </Stack>
                                </FormGroup>


                            </Box>


                        </Grid>
                        <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{

                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto'
                                }}
                            >


                                <Button fullWidth color={"primary"} variant="contained" onClick={(e) => handleDecline()}>Decline <CancelIcon /></Button>


                            </Box>

                        </Grid>
                        <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{

                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto'
                                }}
                            >


                                <Button fullWidth color={"primary"} variant="contained" type="submit" >Agree <DescriptionIcon /></Button>


                            </Box>
                            <Box mb={5} />
                        </Grid>
                    </Grid>
                </form>
            </>
        </Container >
    )
}

export default ViewTerms